<template>
  <div class="page-class page-center">
    <div class="page-staff-form">
      <h1 class="page-title">{{ title }}</h1>
      <role-form-box
        list-url="/roles"
        :id="id"
        checklist-type="roles"
        :form-type="formType"
        @add="onAdd"
        @edit="onEdit"
      >
      </role-form-box>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import RoleFormBox from '../../components/RoleFormBox.vue';

export default {
  name: 'RoleForm',
  components: {
    RoleFormBox
  },
  async mounted() {
    if (this.$route.name === 'role-new') {
      this.formType = 'new';
      this.id = null;
    } else {
      this.formType = 'update';
      this.id = this.$route.params.id;

      await this.getOne({
        type: 'role',
        id: this.id,
        router: this.$router
      });
    }
  },
  data() {
    return {
      formType: '',
      id: null
    };
  },
  computed: {
    title() {
      return this.formType === 'new' ? 'Add New Role' : 'Update Role';
    },
    ...mapState('role', ['loading'])
  },
  methods: {
    ...mapActions('role', ['getOne', 'postOne', 'patchOne']),
    onAdd({ role }) {
      this.postOne({
        role,
        router: this.$router,
        redirectUrl: '/role'
      });
    },
    onEdit({ role }) {
      this.patchOne({
        type: 'role',
        id: this.id,
        role,
        router: this.$router,
        redirectUrl: '/role'
      });
    }
  }
};
</script>
